<template>
  <Transition :name="slideTransition">
    <div
      v-show="activeSide === side"
      class="lensesList"
      :class="side === 'LEFT' ? 'lensesList-left' : 'lensesList-right'"
      style="position: absolute; left: 0; right: 0"
    >
      <ul
        :id="'viewportList' + (side === 'LEFT' ? 'Left' : 'Right')"
        class="viewport"
        :class="side === 'LEFT' ? 'viewport-left' : 'viewport-right'"
        ref="viewportRef"
        @scroll="handleScroll"
      >
        <li v-for="item in store.data" :key="item.id">
          <a class="nav-title nav-entity">{{ item.name }}</a>
          <ul class="nested-list" v-if="item.lenses && item.lenses.length">
            <li
              v-for="lens in uniqueLenses(item.lenses)"
              :key="getLinkId(lens.name, side)"
              class="nav-item nav-entity"
            >
              <a
                @click="setSelection(lens.name)"
                :id="getLinkId(lens.name, side)"
                href="javascript:;"
                class="nav-link"
                >{{ lens.name }}</a
              >
              <span class="new-badge" v-if="lens.isNew">NEW</span>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </Transition>
</template>

<script setup>
import { computed, ref, defineProps, defineExpose } from 'vue'
import { useScenesStore } from '@/stores/Scenes'

const props = defineProps({
  side: {
    type: String,
    required: true,
    validator: value => ['LEFT', 'RIGHT'].includes(value)
  },
  activeSide: {
    type: String,
    required: true
  }
})

const store = useScenesStore()
const viewportRef = ref(null)

const slideTransition = computed(() => (props.side === 'LEFT' ? 'slide-left' : 'slide-right'))

function getLinkId(name, side) {
  return name.toLowerCase().replace(/\s+/g, '-') + '-' + side.toLowerCase()
}

function uniqueLenses(lensCategory) {
  if (lensCategory) {
    const uniqueLensesMap = {}
    lensCategory.forEach(lens => {
      const name = lens.name
      const isNew = lens.isNew
      if (!uniqueLensesMap[name] || isNew) {
        uniqueLensesMap[name] = isNew
      }
    })
    return Object.keys(uniqueLensesMap).map(name => ({
      name,
      isNew: uniqueLensesMap[name]
    }))
  }
  return []
}

function setSelection(lens) {
  const formattedLens = lens.replace(/\s+/g, '-').toLowerCase()
  if (props.side === 'LEFT') {
    store.setLeftSelectedVideoId(formattedLens + '-left')
  } else {
    store.setRightSelectedVideoId(formattedLens + '-right')
  }
}

function handleScroll() {
  store.snapToClosestOption(viewportRef.value, true)
}

defineExpose({
  viewport: viewportRef
})
</script>
